import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

import type { FeaturePayload } from '@/store/types/FeaturePayload'
import type { FeatureName } from '@/store/types/FeaturePayload'

export const useFeatureFlagsStore = defineStore('featureFlags', () => {
  const loaded = ref(false)

  const featureFlags = reactive<Record<FeatureName, boolean>>({
    ASYNC_AUTO_ASSIGNMENT: false,
    ASYNC_BATCH_ACTIONS: false,
    AUTO_LABEL: false,
    CONSENSUS_STAGE_V2_ALL_TOOLS_ENABLED: false,
    EYE_TOOL: false,
    IMAGE_TAG_LOADER: false,
    LEGACY_DICOM: false,
    DYNAMIC_MPR: false,
    SHOW_NON_DEFAULT_V1_TEMPLATE_FF: false,
    SIMPLE_TABLE: false,
    TEST_FEATURE: false,
    TEST_FEATURE_2: false,
    WORKSPACE_PRICING: false,
    _AUTOLABEL_SUPERADMIN: false,
    LONG_VIDEOS: false,
    SENTRY_REPLAY: false,
    FRAMES_MANIFEST_WITH_FRAMES_EXTRACTION: false,
    ANNOTATIONS_PACKAGE: false,
    ENABLE_DEV_CONFIGS: false,
    ANNOTATIONS_PAGINATION: false,
    AUTOTRACK_OBB_OUTPUT: false,
    AUTOTRACK_SKIP_FRAMES: false,
    PARALLEL_BLIND_STAGE: false,
    AUDIO_WAVE: false,
    DISABLE_TEXT_ATTRIBUTES: false,
    WEB_GL_MASK_RENDERING: false,
    QUALITY_REPORT_V2: false,
    BRUSH_WORKER: false,
    SAM_FOR_TILED_IMAGES: false,
    KEYPOINT_3D_TOOL: false,
    DATASET_FILTER_V2: false,
    POINT_BY_POINT_SKELETON: false,
    MASK_INTERPOLATION: false,
    AI_REVIEW_FEEDBACK: false,
  })

  const setFeatures = (newFeatures: FeaturePayload[]): void => {
    newFeatures.forEach((f) => {
      featureFlags[f.name] = f.enabled
    })
    loaded.value = true
  }

  return { setFeatures, featureFlags, loaded }
})
